import LayoutActividad from "../../../components/LayoutActividad";
import { modulo13 } from "../../../routes/Module13";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import Imagen1 from "../../../images/modulo13/intercambio.png";
import Imagen2 from "../../../images/modulo13/guano.png";

const Actividad5 = () => {
  const infoUnidad = modulo13.content[1];
  const infoAct = modulo13.content[1].activities[6];
  const crumbs = [
    {
      title: modulo13.title,
      url: "/" + modulo13.url,
    },
    {
      title:
        modulo13.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo13.content[1].name}: ${modulo13.content[1].activities[7].name}`,
    linkNext: `${modulo13.url}/${modulo13.content[1].path}/${modulo13.content[1].activities[7].path}`,
    titlePrev: `${modulo13.content[1].name}: ${modulo13.content[1].activities[5].name}`,
    linkPrev: `${modulo13.url}/${modulo13.content[1].path}/${modulo13.content[1].activities[5].path}`,
  };

  const metadata = {
    color: modulo13.color,
    title: `${modulo13.title} - ${infoAct.name}`,
    name: modulo13.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <h2 className="mb-5">{infoAct.name}</h2>

      <div className="bg-light p-3 p-md-5 mt-5">
        <div className="row mt-3 align-items-center">
          <div className="col-md-8 col-12 p-md-3">
            <h2 className="mb-4">El acceso y manejo de recursos</h2>

            <p>
              Los pueblos que habitaron nuestro territorio durante el período
              prehispánico mantuvieron un{" "}
              <strong>intercambio permanente</strong> de recursos. Esto les
              permitía acceder a diversos recursos naturales inclusive cuando
              estos no existían en su territorio.
            </p>
          </div>
          <div className="col-md-4 col-12 text-center">
            <img src={Imagen1} className="img-fluid w-100" alt="Peruanos" />
          </div>
          <div className="col-md-4 col-12 text-center">
            <img src={Imagen2} className="img-fluid w-100" alt="Peruanos" />
          </div>
          <div className="col-md-8 col-12 p-md-3">
            <p>
              Posteriormente, el acceso y manejo de los recursos ha sido muy
              controversial, pues no siempre se ha sabido aprovechar para el
              bienestar de todos los peruanos y muchas veces ha generado{" "}
              <strong>riesgos ambientales</strong>.
            </p>
            <p>
              Ejemplos de ello son la <strong>minería</strong> durante la época
              colonial, la explotación del <strong>guano</strong> y el{" "}
              <strong>salitre</strong> en el siglo XIX, la extracción del{" "}
              <strong>caucho</strong> y la <strong>pesca</strong> en el siglo
              XX, y las <strong>industrias extractivas</strong> en el siglo XXI.
            </p>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Pida que lean en silencio el texto titulado: El acceso y manejo de
            recursos. Pregunte:
            <ul>
              <li>
                <i>
                  “¿Qué se quiere resaltar en el texto? (Posible respuesta: A lo
                  largo de la historia, el acceso y manejo de recursos ha
                  cambiado en nuestro país. En el prehispánico las poblaciones
                  accedían a recursos que estaban fuera de sus zonas gracias al
                  intercambio. En la colonia y a lo largo de toda la república,
                  la explotación se concentró solo en ciertos recursos. Esto
                  muchas veces ha generado impactos dañinos en el medio ambiente
                  y no se ha aprovechado para el beneficio de todos los
                  peruanos).”
                </i>
              </li>
            </ul>
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad5;
